<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <div v-if="serviceRequest.users" class="service-request-details">
            <label
              ><b>Service Request No. - </b
              >{{ serviceRequest.serviceRequestNumber }}</label
            ><br />
            <label
              ><b>Customer - </b
              >{{
                serviceRequest.users.firstName +
                  " " +
                  serviceRequest.users.lastName
              }}</label
            ><br />
            <label><b>Phone - </b>{{ serviceRequest.users.phone }}</label
            ><br />
            <label><b>Address - </b> {{ serviceRequest.users.address }}</label
            ><br />
            <label
              ><b>Vendor - </b>
              {{
                serviceRequest.vendor.firstName +
                  " " +
                  serviceRequest.vendor.lastName
              }}</label
            ><br />
          </div>
        </div>
        <div class="card-body service-request-flow">
          <el-steps
            :active="active"
            finish-status="success"
            process-status="finish"
            align-center
          >
            <el-step title="Visit" description="Some description" />
            <el-step title="Quotation" description="Some description" />
            <el-step title="Actual Work" description="Some description" />
            <el-step title="Billing" description="Some description" />
            <el-step title="Accounts" description="Some description" />
          </el-steps>
          <div class="step-body">
            <visit v-if="active === 0" />
            <quotation v-if="active === 1" />
            <work v-if="active === 2" />
            <billing v-if="active === 3" />
            <accounts v-if="active === 4" />
          </div>
          <div class="card-footer">
            <base-button v-if="active != 0" type="primary" @click="previous()"
              >Back</base-button
            >
            <base-button
              v-if="active < 4"
              type="primary"
              style="float: right"
              @click="next()"
              >Next</base-button
            >
            <base-button
              v-if="active === 4"
              type="primary"
              style="float: right"
              @click="finishServiceRequest()"
            >
              Finish</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerComponent from "../../Components/HeaderComponent";
import Visit from "./Visit";
import Work from "./Work";
import Quotation from "./Quatation";
import Billing from "./Billing";
import Accounts from "./Accounts";
import { Step, Steps, Button } from "element-ui";
import { mapActions, mapMutations, mapGetters, mapState } from "vuex";
export default {
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Button.name]: Button,
    headerComponent,
    Billing,
    Visit,
    Quotation,
    Accounts,
    Work
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    ...mapState("serviceRequest", ["serviceRequest"])
  },
  async mounted() {
    if (this.$route.query.activeStep) {
      this.active = parseInt(this.$route.query.activeStep);
    }
    await this.getStatusList();
    await this.fetchServiceRequest(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      updateServiceRequest: "serviceRequest/updateServiceRequest",
      updateServiceRequestData: "serviceRequest/updateServiceRequestData",
      getStatusList: "status/getStatusList",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest"
    }),

    async next() {
      switch (this.active) {
        case 0:
          if (this.active++ > 4) this.active = 0;
          if (this.serviceRequest.status.code != "completed") {
            this.updateServiceRequestData({
              isSiteVisited: this.serviceRequest.isSiteVisited,
              customerCall: this.serviceRequest.customerCall
            });
          }
          break;
        case 1:
          if (this.active++ > 4) this.active = 0;
          break;
        case 2:
          if (this.active++ > 4) this.active = 0;
          break;
        case 3:
          if (this.active++ > 4) this.active = 0;
          break;
        default:
          break;
      }
    },
    previous() {
      if (this.active-- < 0) this.active = 0;
    },
    finishServiceRequest() {
      if (this.serviceRequest.status.code === "completed") {
        this.$router.push("/serviceRequests/list");
      } else {
        this.updateServiceRequestData({}).then(res => {
          this.$router.push("/serviceRequests/list");
          if (res.data.status.code === "completed") {
            this.$notify({
              message: "Service Request Completed Succesfully!",
              type: "success",
              title: "Success"
            });
          } else {
            this.$notify({
              message: "Service Request Is Not Completed Yet!",
              type: "info",
              title: "Success"
            });
          }
        });
      }
    }
  }
};
</script>

<style>
.step-body {
  margin: 40px 30px 30px 30px;
  /* overflow-y: auto; */
  min-height: 450px;
}

.service-request-flow {
  min-height: 500px;
  /* max-height: 650px; */
  position: relative;
  padding: 0;
}

.service-request-flow .card-footer {
  position: absolute;
  background: #d6cece;
  bottom: 0;
  width: 100%;
  padding: 15px;
}
</style>
